import React from "react";
import Input from "./Input";
import { formatPrice } from "../../utils/helpers";

function amountToCents(value) {
  return Math.round(100 * parseFloat(value.replace(/[$,]/, ""))) || 0;
}

class CurrencyInput extends React.Component {
  state = {
    value: formatPrice(this.props.value)
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: formatPrice(this.props.value) });
    }
  }

  handleChange = e => {
    const value = e.target.value;
    this.setState({ value });
    this.props.onChange(amountToCents(value));
  };

  render() {
    const { value, onChange, ...otherProps } = this.props;
    return (
      <Input
        {...otherProps}
        value={this.state.value}
        onChange={this.handleChange}
        onBlur={this.handleChange}
      />
    );
  }
}

export default CurrencyInput;



// WEBPACK FOOTER //
// ./src/components/forms/CurrencyInput.js